// Import essentials
import axios from "axios";
import { useEffect, useState } from "react";

// Bulma Components
import {
  Box,
  Columns,
  Content,
  Heading,
  Image,
  Media,
} from "react-bulma-components";

// API KEY
const API_KEY = "b91803e5ad8c17d71eb17b0404863e99"; //b91803e5ad8c17d71eb17b0404863e99

// Weather Component to show current forecast for the country
const WeatherCard = (props) => {
  const [weather, setWeather] = useState([]);

  // axios to get API data from the site
  useEffect(() => {
    axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather?lat=${props.latlon[0]}&lon=${props.latlon[1]}&units=metric&appid=${API_KEY}`
      )
      .then((response) => {
        let data = response.data.weather[0];
        setWeather(data);
      })
      .catch((err) => console.error(err));
    // console.log(weather)
  }, [props.latlon]);

  return (
    <Columns.Column size={[props.size ? props.size : 7]}>
      <Box>
        <Media>
          <Media.Item align="left">
            {/* Weather Icon */}
            {weather.icon ? (
              <Image
                src={`https://openweathermap.org/img/wn/${weather.icon}@2x.png`}
              />
            ) : ""}
          </Media.Item>
          <Media.Item>
            <Content>
              {/* Forecast */}
              <Heading size={1} textColor="warning">
                {weather.main}
              </Heading>
              {/* More detailed forecast */}
              <Heading size={4} textColor="dark" subtitle>
                {weather.description}
              </Heading>
            </Content>
          </Media.Item>
        </Media>
      </Box>
    </Columns.Column>
  );
};

export default WeatherCard;
